import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { UserAuth } from "./userAuth"
import { IUserAuth } from "./userAuth.types"
import { AccountInfo } from "@azure/msal-browser"
import { Role } from "@/services/PermissionsService"

export const UserAuthParser: IParser<IUserAuth, AccountInfo> = {
  toDomain: (data: AccountInfo) => {
    try {
      return new UserAuth({
        environment: data.environment,
        homeAccountId: data.homeAccountId,
        localAccountId: data.localAccountId,
        tenantId: data.tenantId,
        username: data.username,
        name: data?.name ?? data.username,
        roles: (data.idTokenClaims?.roles as Role[]) ?? [],
        aud: data.idTokenClaims?.aud,
        exp: data.idTokenClaims?.exp,
        oid: data.idTokenClaims?.oid,
      })
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
